<nav class="navbar custom-navbar main-footer small px-3">
  <ul class="navbar-nav me-auto">
    <li class="nav-item">
      <a class="nav-link text-color" href="javascript:;">
        <span>Copyright &copy; 2019</span> <span class="text-uppercase">Seam Labs</span>. All rights reserved
      </a>
    </li>
  </ul>

</nav>
